import React, { useEffect, useState } from "react";
import { Card, Row, Col, Badge, Modal, Carousel } from "react-bootstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import PageLayout from "../../../layouts/PageLayout";


export default function ViewTraining() {
  const { id } = useParams();

  const [training, setTraining] = useState(null);
  const [showSlider, setShowSlider] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

  useEffect(() => {
    fetchTraining();
  }, []);

  const fetchTraining = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/vocational-training/${id}`
      );

      setTraining(res.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  if (!training) {
    return (
      <PageLayout>
        <Card>
          <Card.Body>Loading...</Card.Body>
        </Card>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <Card>
        <Card.Header>
          <h4>Vocational Training Details</h4>
        </Card.Header>

        <Card.Body>
          <Row>
            <Col md={6}>
              <p>
                <strong>Family:</strong>{" "}
                {training.family?.f_number}
              </p>
            </Col>

            <Col md={6}>
              <p>
                <strong>Student:</strong>{" "}
                {training.student_name}
              </p>
            </Col>

            <Col md={6}>
              <p>
                <strong>Relation:</strong>{" "}
                {training.relation}
              </p>
            </Col>

            <Col md={6}>
              <p>
                <strong>Institute:</strong>{" "}
                {training.institute?.name}
              </p>
            </Col>

            <Col md={6}>
              <p>
                <strong>Training:</strong>{" "}
                {training.course?.course_name}
              </p>
            </Col>

            <Col md={6}>
              <p>
                <strong>Duration:</strong>{" "}
                {training.duration}
              </p>
            </Col>

            <Col md={6}>
              <p>
                <strong>Fee:</strong>{" "}
                Rs. {training.fee}
              </p>
            </Col>

            <Col md={6}>
              <p>
                <strong>Status:</strong>{" "}
                <Badge bg="success">
                  {training.progress}
                </Badge>
              </p>
            </Col>

            <Col md={6}>
              <p>
                <strong>Start Date:</strong>{" "}
                {training.start_date}
              </p>
            </Col>

            <Col md={6}>
              <p>
                <strong>End Date:</strong>{" "}
                {training.end_date || "-"}
              </p>
            </Col>

            <Col md={12}>
              <p>
                <strong>Story:</strong>
              </p>
              <div className="border p-3 rounded">
                {training.story}
              </div>
            </Col>

            {training.before_image && (
              <Col xs={12} md={6} className="mt-4">
                <h6>Before Image</h6>
                <img
                  src={`${process.env.REACT_APP_IMG_URL}/${training.before_image}`}
                  alt="Before"
                  className="img-fluid rounded w-100 border"
                  style={{
                    maxHeight: "450px",
                    objectFit: "contain",
                  }}
                />
              </Col>
            )}

            {training.after_image && (
              <Col xs={12} md={6} className="mt-4">
                <h6>After Image</h6>
                <img
                  src={`${process.env.REACT_APP_IMG_URL}/${training.after_image}`}
                  alt="After"
                  className="img-fluid rounded w-100 border"
                  style={{
                    maxHeight: "450px",
                    objectFit: "contain",
                  }}
                />
              </Col>
            )}
            {training.fee_receipt && (
              <Col md={12} className="mt-4">
                <a
                  href={`${process.env.REACT_APP_IMG_URL}/${training.fee_receipt}`}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-primary"
                >
                  View Fee Receipt
                </a>
              </Col>
            )}
            <Col md={12} className="mt-5">
              <Carousel
                activeIndex={activeIndex}
                onSelect={(selectedIndex) => setActiveIndex(selectedIndex)}
                interval={null}
              >
                {training.gallery?.map((item) => (
                  <Carousel.Item key={item.id}>
                    <img
                      src={`${process.env.REACT_APP_IMG_URL}${item.img}`}
                      className="d-block w-100"
                      style={{
                        height: "500px",
                        objectFit: "contain",
                      }}
                      alt=""
                    />
                  </Carousel.Item>
                ))}
              </Carousel>

              <div className="d-flex gap-2 mt-3 flex-wrap justify-content-center">
                {training.gallery?.map((item, index) => (
                  <img
                    key={item.id}
                    src={`${process.env.REACT_APP_IMG_URL}${item.img}`}
                    alt=""
                    onClick={() => setActiveIndex(index)}
                    style={{
                      width: "80px",
                      height: "80px",
                      objectFit: "cover",
                      cursor: "pointer",
                      border:
                        activeIndex === index
                          ? "3px solid #0d6efd"
                          : "1px solid #ddd",
                      borderRadius: "5px",
                    }}
                  />
                ))}
              </div>
            </Col>
            {training.video && (
              <Col xs={12} className="mt-4">
                <h6>Training Video</h6>

                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    paddingTop: "56.25%", // 16:9 ratio
                    borderRadius: "8px",
                    overflow: "hidden",
                    background: "#000",
                  }}
                >
                  <video
                    controls
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  >
                    <source
                      src={`${process.env.REACT_APP_IMG_URL}/${training.video}`}
                      type="video/mp4"
                    />
                  </video>
                </div>
              </Col>
            )}
          </Row>
        </Card.Body>
      </Card>
    </PageLayout>
  );
}